export const smallPhoneSize = window.innerWidth <=400;

export const phoneSize = window.innerWidth <= 600;

export const tabletSize = window.innerWidth <= 1024;

export const smallDesktopSize = window.innerWidth <= 1200;

export const desktopSize = window.innerWidth <= 1440;

export const bigDesktopSize = window.innerWidth > 1441;

export const getProperSize = (smallPhoneValue, phoneValue, tabletValue, smallDesktopValue, desktopValue, bigDesktopValue) => {
    if (smallPhoneSize) {
        return smallPhoneValue;
    } else if (phoneSize) {
        return phoneValue;
    } else if (tabletSize) {
        return tabletValue;
    }else if (smallDesktopSize) {
        return smallDesktopValue;
    } else if (desktopSize) {
        return desktopValue;
    } else if (bigDesktopSize) {
        return bigDesktopValue;
    }
}
